import { Icon, l } from '@manychat/manyui'

import { FlowChartIconBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartIconBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import {
  ConverterRule,
  NodeConverterRulePayload,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { DEFAULT_ICON_RENDER_SIZE } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import { FlowChartNodeType } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartNodeType'
import { FlowChartStartingStepNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartStartingStepNode'
import { NodeType } from 'common/builder/constants/NodeType'
import { IStartingStepNode } from 'common/builder/nodes/nodeInterfaces'

export const StartingStepNodeGenericConverterRule: ConverterRule<
  IStartingStepNode,
  FlowChartStartingStepNode,
  NodeConverterRulePayload
> = {
  predicate: (entity: IStartingStepNode) => entity?.nodeType === NodeType.STARTING_STEP,

  convert: (
    entity: IStartingStepNode,
    { flowChartTriggers }: NodeConverterRulePayload,
  ): FlowChartStartingStepNode | null => {
    return {
      id: entity.id,
      type: FlowChartNodeType.STARTING_STEP,
      nodeType: NodeType.STARTING_STEP,
      onboardingElementId: entity.onboardingElementId,
      data: {
        header: {
          icon: new FlowChartIconBuilder(Icon.OrphanAction, DEFAULT_ICON_RENDER_SIZE).build(),
          title: l.translate('When...'),
        },
        triggers: flowChartTriggers,
        nextStep: new FlowChartNextStepBuilder(entity.id).withLabel(l.translate('Then')).build(),
      },
    }
  },
}
